import { primaryColourMain } from 'app/agriculture/material';

export function SelectedPoint() {
    return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
            fill="#ffffff"
            stroke="${primaryColourMain}"
            stroke-width="4"
            r="10"
            id="circle"
            cy="12"
            cx="12" />
    </svg>`;
}
